import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export type ViewMode = 'simple' | 'advanced';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private sidebarModeSubject = new BehaviorSubject<boolean>(false);
  public sidebarMode$: Observable<boolean> = this.sidebarModeSubject.asObservable();

  private viewModeSubject = new BehaviorSubject<ViewMode>('simple');
  public viewMode$: Observable<ViewMode> = this.viewModeSubject.asObservable();

  private dashboardResetSubject = new Subject<void>();
  public dashboardReset$: Observable<void> = this.dashboardResetSubject.asObservable();

  setSidebarMode(isActive: boolean): void {
    this.sidebarModeSubject.next(isActive);
  }

  getSidebarMode(): boolean {
    return this.sidebarModeSubject.value;
  }

  setViewMode(mode: ViewMode): void {
    this.viewModeSubject.next(mode);
  }

  getViewMode(): ViewMode {
    return this.viewModeSubject.value;
  }

  isSimpleMode(): boolean {
    return this.viewModeSubject.value === 'simple';
  }

  isAdvancedMode(): boolean {
    return this.viewModeSubject.value === 'advanced';
  }

  triggerDashboardReset(): void {
    this.dashboardResetSubject.next();
  }
}
